(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[431],{

/***/ 3920:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[articleHandle]",
      function () {
        return __webpack_require__(1934);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Article; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _templates_article__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8237);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3183);
/* eslint-disable import/no-unresolved */ 







var __N_SSG = true;
function Article(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var article = props.article;
    var setArticle = _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.store.recoil.useRecoilState(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.store.state.article)[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setArticle(article);
    }, [
        article === null || article === void 0 ? void 0 : article.handle
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .PageErrorBoundary */ .bg, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .PageHead */ .yG, {
            page: article,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates_article__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                renderSections: renderSections
            }))
        })
    });
}


/***/ }),

/***/ 8237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArticleTemplate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_handleize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5979);
/* harmony import */ var _snippets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1790);





function ProgressBar(props) {
    var scroll = props.scroll;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed top-[60px] z-[10] h-[4px] w-full bg-[#fff] lg:top-[83px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "progress fixed top-[60px] z-[10] h-[4px] w-full lg:top-[83px]",
                style: {
                    background: "linear-gradient(to right, #C1EFFA ".concat(scroll, ", #8DCEF9, transparent  0)")
                }
            })
        ]
    });
}
function ArticleTemplate(param) {
    var article = param.article, renderSections = param.renderSections;
    var settings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.useArticle)();
    var date = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var options = {
            year: "numeric",
            month: "long",
            day: "numeric"
        };
        return new Date(article.publishedAt || article.createdAt).toLocaleDateString("en-US", options);
    }, [
        article.createdAt,
        article.publishedAt
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), sectionTitles = ref[0], setSectionTitles = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), scrollPosition = ref1[0], setScrollPosition = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isOpen = ref2[0], setIsOpen = ref2[1];
    var filteredArticleHero = function() {
        return renderSections().filter(function(item) {
            return item.props["data-comp"].includes("articleHero") || item.props["data-comp"].includes("dynamicArticleHero");
        });
    };
    var filteredArticleSections = function() {
        return renderSections().filter(function(item) {
            return item.props["data-comp"].includes("article") && !(item.props["data-comp"].includes("articleHero") || item.props["data-comp"].includes("dynamicArticleHero"));
        });
    };
    var filteredSections = function() {
        return renderSections().filter(function(item) {
            return !item.props["data-comp"].includes("article") && !item.props["data-comp"].includes("dynamicArticleHero");
        });
    };
    var getTableOfContents = function() {
        if (renderSections().length) {
            var sectionTitlesNew = [];
            filteredArticleSections().forEach(function(item) {
                var sectionData = item.props.children.props.children.props.cms;
                if ((sectionData === null || sectionData === void 0 ? void 0 : sectionData.anchorId) && (sectionData === null || sectionData === void 0 ? void 0 : sectionData.anchorId.length)) {
                    var sectionTitleData = {
                        title: sectionData.anchorId,
                        handle: (0,_utils_handleize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(sectionData.anchorId)
                    };
                    sectionTitlesNew.push(sectionTitleData);
                }
            });
            setSectionTitles(sectionTitlesNew);
        }
    };
    var scrollToView = function(titleID) {
        document.getElementById(titleID).scrollIntoView();
    };
    var scrollToViewMobile = function(titleID) {
        setIsOpen(!isOpen);
        document.getElementById(titleID).scrollIntoView();
    };
    var toggleDropdown = function() {
        setIsOpen(!isOpen);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getTableOfContents();
    }, []);
    var isInViewport = function(element) {
        try {
            if (!(document === null || document === void 0 ? void 0 : document.querySelector(element))) return;
            var rect = document.querySelector(element).getBoundingClientRect();
            return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        } catch (e) {
            console.log('There was an error determining if this ID "'.concat(element, "\" was in the viewport. Please ensure the ID you're using is valid"));
        }
    };
    var getDocHeight = function() {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    };
    var calculateScrollDistance = function() {
        var scrollTop = window.pageYOffset;
        var windowHeight = window.innerHeight;
        var docHeight = getDocHeight();
        var totalDocScrollLength = docHeight - windowHeight;
        setScrollPosition(Math.floor(scrollTop / totalDocScrollLength * 100));
    };
    var listenToScrollEvent = function() {
        document.addEventListener("scroll", function() {
            requestAnimationFrame(function() {
                calculateScrollDistance();
            });
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        listenToScrollEvent();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets__WEBPACK_IMPORTED_MODULE_3__/* .ArticleTableOfContents */ .Yf, {
                titles: sectionTitles,
                scrollToView: scrollToViewMobile,
                isInViewport: isInViewport
            }),
            !!filteredArticleHero().length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:mb-8",
                children: filteredArticleHero()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProgressBar, {
                scroll: "".concat(scrollPosition, "%")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-contained px-contained text-primary",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "lg:flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative max-w-[290px] lg:w-1/5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relatvie sticky top-32 hidden lg:block",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        type: "button",
                                        className: "relative mb-8 flex w-full cursor-pointer border-b border-[#202635] pb-6 text-[16px] font-[400] uppercase tracking-[.04em]",
                                        onClick: function() {
                                            return toggleDropdown();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "TABLE OF CONTENTS"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "absolute right-0 top-[12px] -translate-y-1/2 ".concat(isOpen ? "true" : "block rotate-180 transform"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                    width: "12",
                                                    height: "6",
                                                    viewBox: "0 0 12 6",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                        d: "M6 0L0.803848 5.25H11.1962L6 0Z",
                                                        fill: "#202635"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    isOpen && sectionTitles.map(function(item, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            type: "button",
                                            className: "group relative mb-6 w-full cursor-pointer border-b border-[#DDE2E7] pb-6 text-left font-[400] last:border-b-0 hover:text-[#202635] ".concat(isInViewport("#".concat(item.handle)) ? "text-[#202635]" : "text-shadowGray"),
                                            onClick: function() {
                                                return scrollToView(item.handle);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "absolute bottom-0 left-0 h-[1px] w-full bg-gradient-to-r from-[#F1DCC1] via-[#8DCEF9] to-[#2179C2] group-hover:opacity-100 ".concat(isInViewport("#".concat(item.handle)) ? "opacity-100" : "opacity-0")
                                                }),
                                                item.title
                                            ]
                                        }, index);
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "max-w-[765px] lg:ml-20",
                            children: filteredArticleSections()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: filteredSections()
            })
        ]
    });
}
ArticleTemplate.displayName = "ArticleTemplate";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3920); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);